<template>
    <v-container>
        <v-row no-gutters>
            <v-col
                cols="12"
                md="4"
                sm="4"
            >
                <h1>Purchase</h1>
            </v-col>
            <v-col
                cols="12"
                md="2"
                sm="2"
            >
                <v-switch
                v-model="gmwswitch"
                color="red"
                label="GMW"
                hide-details
                ></v-switch>
            </v-col>
            <v-col
                cols="12"
                md="2"
                sm="2"
            >
                <v-switch
                v-model="smswitch"
                color="red"
                label="SM"
                hide-details
                :disabled="disabledSMSwitch"
                ></v-switch>
            </v-col>
            
            <v-spacer></v-spacer>
            <v-row justify="center">
                <v-col cols="auto">
                    <v-btn color="purple" @click="gmgmwform()" >
                        GM-GMW
                    </v-btn>
                </v-col>
                <v-col cols="auto">
                    <v-btn color="success" @click="creategmwform()" >
                        GMW/SM Purchase
                    </v-btn>
                </v-col>
                <v-col cols="auto">
                    <v-btn color="blue" @click="creategmform()" >
                        GM Purchase
                    </v-btn>
                </v-col>
            </v-row>
            
            
        </v-row>
        <!-- Data Table for GMW & SM -->
        <div v-if="gmwswitch || (!gmwswitch && smswitch)">
            <v-data-table
                :headers="gmwheaders"
                :items="filteredBills"
            >
                <template v-slot:thead>
                    <tr>
                        <td>
                            <v-text-field v-model="partysearch" class="ma-2" density="compact" placeholder="Party..." hide-details></v-text-field>
                        </td>
                        <td>
                            <v-text-field v-model="billnosearch" class="ma-2" density="compact" placeholder="Bill No..." hide-details></v-text-field>
                        </td>
                        <td>
                            <v-text-field v-model="billdatesearch" class="ma-2" density="compact" placeholder="Bill Date..." hide-details></v-text-field>
                        </td>
                        <td>
                            <v-text-field v-model="amountsearch" class="ma-2" density="compact" placeholder="Greater Than" hide-details></v-text-field>
                        </td>
                    </tr>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                    <v-icon
                        class="me-2"
                        size="small"
                        @click="editItemGmwSm(item)"
                    >
                        mdi-pencil
                    </v-icon>
                    <v-icon
                        class="me-2"
                        size="small"
                        @click="deleteItemGmwSm(item)"
                    >
                        mdi-trash-can-outline
                    </v-icon>
                </template>
            </v-data-table>
        </div>

        <!-- Data Table for GM -->
        <div v-if="!gmwswitch && !smswitch">
            <v-data-table
                :headers="gmheaders"
                :items="filteredBillsgm"
            >
                <template v-slot:thead>
                    <tr>
                        <td>
                            <v-text-field v-model="partysearchgm" class="ma-2" density="compact" placeholder="Party..." hide-details></v-text-field>
                        </td>
                        <td>
                            <v-text-field v-model="billnosearchgm" class="ma-2" density="compact" placeholder="Bill No..." hide-details></v-text-field>
                        </td>
                        <td>
                            <v-text-field v-model="billdatesearchgm" class="ma-2" density="compact" placeholder="Bill Date..." hide-details></v-text-field>
                        </td>
                        <td>
                            <v-text-field v-model="amountsearchgm" class="ma-2" density="compact" placeholder="Greater Than" hide-details></v-text-field>
                        </td>
                    </tr>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                    <v-icon
                        class="me-2"
                        size="small"
                        @click="editItemGM(item)"
                    >
                        mdi-pencil
                    </v-icon>
                    <v-icon
                        class="me-2"
                        size="small"
                        @click="deleteItemGM(item)"
                    >
                        mdi-trash-can-outline
                    </v-icon>
                </template>
            </v-data-table>
        </div>
        <div v-if="showGmForm">
            <GMForm :showGmForm="showGmForm" :editedItem="editedItemGM" :editedIndex="editedIndexGM" :updateID="updateIDGM" @closegmdialog="closegmdialog"/>
        </div>
        <div v-if="showGmwForm">
            <GMWForm :showGmwForm="showGmwForm" :editedItem="editedItemGMW" :editedIndex="editedIndexGMW" :updateID="updateIDGMW"  :gmwswitch="gmwswitch" @closegmwdialog="closegmwdialog"/>
        </div>
        <div v-if="showGmGmwForm">
            <GMGMwForm :showGmGmwForm="showGmGmwForm" @closegmgmwdialog="closegmgmwdialog"/>
        </div>
        <div v-if="showMessage">
            <ShowError @closesnackbar="closesnackbar"/>
        </div>
    </v-container>
</template>
<script setup>
    import { ref, provide, computed, onMounted,onBeforeMount, watch } from 'vue'
    import { useAuthStore } from '@/stores/AuthStore'
    import PurchaseService from '@/services/PurchaseService'
    import GMGMwForm from '@/views/purchase/gmtowsform'
    import GMForm from '@/views/purchase/formgm'
    import GMWForm from '@/views/purchase/formgmw'
    import ShowError from '@/components/Showerror'
    import router from '@/router'

    const authStore = useAuthStore()
    //var gmwswitch = ref(authStore.gmswitch)
    var gmwswitch = ref(authStore.gmswitch)
    var smswitch = ref(false)
    var disabledSMSwitch = ref(false)

    var purchases = ref([])
    var gmpurchases = ref([])
    var smpurchases = ref([])
    var gmwpurchases = ref([])
    

    var showMessage = ref(false)
    var msgStatus = ref('primary')
    var msg = ref('This is msg')

    var showGmGmwForm=ref(false)

    provide('msgStatus', msgStatus)
    provide('msg', msg)
    provide('showMessage', showMessage)

    var editedItemGM = ref({})
    var editedIndexGM = ref(-1)
    var updateIDGM = ref(0)

    var editedItemGMW = ref({
        puritems:[]
    })
    var editedIndexGMW = ref(-1)
    var updateIDGMW = ref(0)

    var gmwheaders = ref([
        {
          title: 'Party',
          align: 'start',
          sortable: true,
          key: 'ps_vname',
        },
        { title: 'Bill No', key: 'ps_chbillno' },
        { title: 'Bill Date', key: 'ps_chdate' },
        { title: 'Amount', key: 'ps_billamount' },
        { title: 'Actions', key: 'actions', sortable: false },
    ])

    var gmheaders = ref([
        {
          title: 'Party',
          align: 'start',
          sortable: true,
          key: 'vname',
        },
        { title: 'Bill No', key: 'billno' },
        { title: 'Bill Date', key: 'billdate' },
        { title: 'Amount', key: 'amnt' },
        { title: 'Actions', key: 'actions', sortable: false },
    ])

    var headers = (gmwswitch.value) ? gmwheaders.value : ((smswitch.value) ? gmwheaders.value : gmheaders.value)

    var billdatesearch = ref('')
    var billnosearch = ref('')
    var partysearch = ref('')
    var amountsearch = ref('')

    var billdatesearchgm = ref('')
    var billnosearchgm = ref('')
    var partysearchgm = ref('')
    var amountsearchgm = ref('')

    var showGmForm = ref(false)
    var showGmwForm = ref(false)

    async function creategmform(){
        console.log("Create Form is called")
        showGmForm.value = true
    }

    async function creategmwform(){
        console.log("Create Form is called")
        showGmwForm.value = true
    }

    async function getpurchasesfromgm(){
        try{
            var bills = (await PurchaseService.getall()).data
            //gmpurchases.value = bills
        }catch(err){
            showMessage.value = true
            msgStatus.value = 'error'
            msg.value = err.response.data.error
        }
        return bills
        
    }

    async function getpurchasesfromsm(){
        try{
            var bills = (await PurchaseService.getallsm()).data
            //gmpurchases.value = bills
        }catch(err){
            showMessage.value = true
            msgStatus.value = 'error'
            msg.value = err.response.data.error
        }
        return bills
        
    }

    async function getpurchasesfromgmw(){
        try{
            var bills = (await PurchaseService.getallgmw()).data
            //gmwpurchases.value = bills
        }catch(err){
            showMessage.value = true
            msgStatus.value = 'error'
            msg.value = err.response.data.error
        }
        
        return bills
    }

    function closesnackbar (){
        showMessage.value = false
    }

    async function editItemGM(item){
        editedIndexGM.value = purchases.value.indexOf(item)
        updateIDGM.value = item.id
        //var bill = gmwswitch.value ? (await BillService.getbillgmw(item.billid)).data : (await BillService.getbill(item.billid)).data
        editedItemGM.value = Object.assign({}, item)
        showGmForm.value = true
    }

    async function editItemGmwSm(item){
        editedIndexGMW.value = purchases.value.indexOf(item)
        updateIDGMW.value = item.ps_id
        //var bill = gmwswitch.value ? (await BillService.getbillgmw(item.billid)).data : (await BillService.getbill(item.billid)).data
        editedItemGMW.value = Object.assign({}, item)
        showGmwForm.value = true
    }

    // function closedialog (){
    //     console.log('Close dialog is called')
    //     showForm.value = false
    //     //router.go(0)
    // }

    function closegmgmwdialog (){
        console.log('Close gmgw dialog is called')
        showGmGmwForm.value = false
        router.go(0)
    }
    function closegmdialog (){
        console.log('Close gm dialog is called')
        showGmForm.value = false
        router.go(0)
    }
    function closegmwdialog (){
        console.log('Close gmw dialog is called')
        showGmwForm.value = false
        router.go(0)
    }

    function gmgmwform(){
        showGmGmwForm.value = true
    }

    onBeforeMount(async () => {
        //var gmbills = await getpurchasesfromgm()
        gmwpurchases.value = await getpurchasesfromgmw()
        gmpurchases.value = await getpurchasesfromgm()
        smpurchases.value = await getpurchasesfromsm()

        //purchases.value = gmwswitch.value ? gmwbills : gmbills
        purchases.value = (gmwswitch.value) ? gmwpurchases.value : ((smswitch.value)? smpurchases.value : gmpurchases.value)
        disabledSMSwitch.value = (gmwswitch.value) ? true : false
    })

    watch(gmwswitch, async(val)=>{
        authStore.setGmswitch()
        if(gmwswitch.value){
            smswitch.value = false
            disabledSMSwitch.value = true
            purchases.value = gmwpurchases.value
        }else{
            disabledSMSwitch.value = false
            if(smswitch.value){
                purchases.value = smpurchases.value
            }else{
                purchases.value = gmpurchases.value
            }
        }
        console.log("After changing GMSWITH")
        //bills.value = gmwswitch.value ? gmwbills.value : gmbills.value
    })

    watch(smswitch, async(val)=>{
        if(smswitch.value){
            purchases.value = smpurchases.value
        }else{
            if(!gmwswitch.value){
                purchases.value = gmpurchases.value
            }
        }
        //bills.value = gmwswitch.value ? gmwbills.value : gmbills.value
    })

    function filterBillno(item){
        return item.ps_chbillno.toLowerCase().includes(billnosearch.value.toLowerCase())   
    }
    function filterBilldate(item){
        return item.ps_chdate.toLowerCase().includes(billdatesearch.value.toLowerCase())
    }
    function filterParty(item){
        return item.ps_vname.toLowerCase().includes(partysearch.value.toLowerCase())
    }
    function filterAmount(item){
        return item.ps_billamount >= amountsearch.value        
    }

    const filteredBills = computed(() => {
        var conditions = []

        if(billnosearch.value){
            conditions.push(filterBillno)
        }

        if(billdatesearch.value){
            conditions.push(filterBilldate)
        }

        if(partysearch.value){
            conditions.push(filterParty)
        }

        if(amountsearch.value){
            conditions.push(filterAmount)
        }

        if(conditions.length > 0){
            return purchases.value.filter((bill) => {
                return conditions.every((condition) => {
                    return condition(bill)
                })
            })
        }

        return purchases.value
    })

    function filterBillnogm(item){
        return item.billno.toLowerCase().includes(billnosearchgm.value.toLowerCase())   
    }
    function filterBilldategm(item){
        return item.billdate.toLowerCase().includes(billdatesearchgm.value.toLowerCase())
    }
    function filterPartygm(item){
        return item.vname.toLowerCase().includes(partysearchgm.value.toLowerCase())
    }
    function filterAmountgm(item){
        return item.billamount >= amountsearchgm.value        
    }

    const filteredBillsgm = computed(() => {
        var conditions = []

        if(billnosearchgm.value){
            conditions.push(filterBillnogm)
        }

        if(billdatesearchgm.value){
            conditions.push(filterBilldategm)
        }

        if(partysearchgm.value){
            conditions.push(filterPartygm)
        }

        if(amountsearchgm.value){
            conditions.push(filterAmountgm)
        }

        if(conditions.length > 0){
            return purchases.value.filter((bill) => {
                return conditions.every((condition) => {
                    return condition(bill)
                })
            })
        }

        return purchases.value
    })
</script>